import { LegsHistoryDataTable, LegsHistoryFilters } from './components';
import { useLegsHistory } from './hooks';
import './LegsHistory.scss';

interface Props {
  isAdmin?: boolean;
}

export default function LegsHistory({
  isAdmin = false,
}: Props) {
  const {
    search,
    onChangeSearch,
    startDate,
    endDate,
    onChangeDateRange,
    onChangeDateRangeRaw,
    userEmail,
    onChangeUserEmail,
    usersOptions,
    subAccountNumber,
    onChangeSubAccountNumber,
    data,
    page,
    onChangePage,
    pageSize,
    onChangePageSize,
    count,
    pages,
    loading,
  } = useLegsHistory(isAdmin);

  return (
    <div className='LegsHistory'>
      <LegsHistoryFilters
        search={search}
        onChangeSearch={onChangeSearch}
        startDate={startDate}
        endDate={endDate}
        onChangeDateRange={onChangeDateRange}
        onChangeDateRangeRaw={onChangeDateRangeRaw}
        userEmail={userEmail}
        onChangeUserEmail={onChangeUserEmail}
        usersOptions={usersOptions}
        subAccountNumber={subAccountNumber}
        onChangeSubAccountNumber={onChangeSubAccountNumber}
        isAdmin={isAdmin}
      />
      <LegsHistoryDataTable
        data={data}
        page={page}
        onChangePage={onChangePage}
        pageSize={pageSize}
        onChangePageSize={onChangePageSize}
        count={count}
        pages={pages}
        loading={loading}
        isAdmin={isAdmin}
      />
    </div>
  );
}
